var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1005",
    d: "M0-682.665H14v14H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41435",
    "data-name": "Group 41435",
    transform: "translate(18901 7383)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15706",
    "data-name": "Rectangle 15706",
    width: 16,
    height: 16,
    transform: "translate(-18901 -7383)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g999",
    transform: "translate(-18900 -6699.335)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1001",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1003",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1009",
    transform: "translate(8.419 0.55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1011",
    d: "M-171.084-171.084h-2.488a1.094,1.094,0,0,1-1.094-1.094v-2.488",
    transform: "translate(174.666 174.666)",
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1013",
    transform: "translate(1.996 0.547)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1015",
    d: "M-477.846-171.229V-163a1.094,1.094,0,0,1-1.094,1.094h-7.817A1.094,1.094,0,0,1-487.851-163V-173.72a1.094,1.094,0,0,1,1.094-1.094h5.344Z",
    transform: "translate(487.851 174.814)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1017",
    transform: "translate(6.973 6.453)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1019",
    d: "M0-189.282v-3.963",
    transform: "translate(0 193.245)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1021",
    transform: "translate(5.46 9.233)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1023",
    d: "M0,0,1.513,1.513,3.026,0",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: 1
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadFile);
export default __webpack_public_path__ + "static/media/download-file.c4ed761e8223f44b03f7f73e25ad4423.svg";
export { ForwardRef as ReactComponent };